<template lang="pug">
	.web-service--complex-parameter.flex-row.space
		DxButton(icon="trash", stylingMode="text", type="danger" @click="$emit('delete')")
		.flex-col
			.font-small.upper.grey {{$tCaption('Name')}}
			DxTextBox(:value.sync="param.Name", @value-changed="$emit('change')", value-change-event="input")
		.flex-col
			.font-small.upper.grey {{$tCaption('Caption')}}
			DxTextBox(:value="param.Caption", @value-changed="e => $set(param, 'Caption', e.value)")
		.flex-col
			.font-small.upper.grey {{$tCaption('Description')}}
			DxTextBox(:value.sync="param.Description")
		.flex-col
			.font-small.upper.grey {{$tCaption('Complex type')}}
			DxSelectBox(:items="$complexParameterTypes", value-expr="id", display-expr="name", :search-enabled="false", :value.sync="param.Type", :width="120", @value-changed="$emit('change')")
		.flex-col(v-if="keys.length")
			.font-small.upper.grey {{$tCaption('Parameters')}}
			Dropdown(ref="keysDropdown", :getTotal="(r) => r.length", :getItems="(r) => r", :getData="getKeysData",
				:watchReload="keys",
				:columns="[{ dataField: 'name', caption: $tCaption('Name') }]",
				displayExpr="name",
				valueExpr="name",
				:placeholder="$tCaption('Output')",
				:selectedItems="param.Keys || []",
				:showColumnHeaders="false",
				:filtersVisible="false",
				:searchVisible="true",
				:multiple="true",
				@change="(v) => { $set(param, 'Keys', v); $emit('change'); }")
		.flex-col.space
			.font-small.upper.grey {{$tCaption('Options')}}
			DxCheckBox(:value="param.IsRequired || false", :text="$tCaption('Required')", @value-changed="e => $set(param, 'IsRequired', e.value)")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxSelectBox from 'devextreme-vue/select-box';
	import Dropdown from 'app-core/Dropdown.vue';
	import { DxCheckBox } from 'devextreme-vue/check-box';

	export default {
		translationCategory: 'webServiceCaller.StructureBuilder',
		name: 'web-service--complex-parameter',
		components: { DxButton, DxTextBox, DxSelectBox, Dropdown, DxCheckBox },
		model: {
		},
		props: ['param', 'complexTypes'],
		data() {
			this.$complexParameterTypes = Object.keys(this.$Data.complexExternalServicesTypes).map((f) => ({ id: f, name: this.$Data.complexExternalServicesTypes[f]?.name || this.$Data.capitalize(f) }));
			return {
			};
		},		
		computed: {
			keys() {
				return (this.$Data.complexExternalServicesTypes[this.param.Type]?.parameters || []).map(f => ({ id: f.name, name: f.name }));
			}
		},
		watch: {
		},
		mounted() {
			if (__DEBUG__)
				window.complexParameter = this;
		},		
		destroyed() {
			delete this.$complexParameterTypes;
		},
		methods: {
			getKeysData() {
				return Promise.resolve(this.keys);
			},
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.web-service--complex-parameter {
	}
</style>
